import React, { Children } from 'react'
import flattenChildren from 'react-keyed-flatten-children'

import { Box } from '../Box/Box'
import { SpaceProp } from '../Box/Box.types'
import { Divider } from '../Divider/Divider'
import { useScreenSize } from '../../hooks/useScreenSize'
import useResponsiveProp from '../../hooks/useResponsiveProp'

export interface StackProps extends BaseProps {
  children: React.ReactNode
  space?: ResponsiveProp<SpaceProp>
  align?: ResponsiveProp<'start' | 'center' | 'end'>
  dividers?: ResponsiveProp<boolean>
  outsideDividers?: ResponsiveProp<boolean>
}

export const Stack: React.FC<StackProps> = ({
  space,
  align,
  dividers,
  outsideDividers,
  ...props
}) => {
  const stackItems = flattenChildren(props.children)

  const device = useScreenSize()

  const responsiveSpace = useResponsiveProp(space, device)
  const responsiveAlign = useResponsiveProp(align, device)
  const responsiveDividers = useResponsiveProp(dividers, device)
  const responsiveOutsideDividers = useResponsiveProp(outsideDividers, device)

  return (
    <Box
      negativeMarginTop={responsiveSpace}
      className="stack-wrapper"
      width="100%"
      pointerEvents="none"
      {...props}
    >
      {responsiveOutsideDividers && (
        <Box width="100%">
          <Divider />
        </Box>
      )}
      {Children.map(stackItems, (child, index) => (
        <Box
          paddingTop={responsiveSpace}
          display="flex"
          flexDirection="column"
          alignItems={responsiveAlign}
          pointerEvents="all"
          height={props.height}
        >
          {responsiveDividers && index > 0 ? (
            <Box paddingBottom={responsiveSpace} width="100%">
              <Divider />
            </Box>
          ) : null}
          {child}
        </Box>
      ))}
      {responsiveOutsideDividers && (
        <Box paddingTop={responsiveSpace} width="100%">
          <Divider />
        </Box>
      )}
    </Box>
  )
}
